const actionTypes = {
  TOGGLE_TRANSFER_MODAL_VISIBLE: Symbol('TOGGLE_TRANSFER_MODAL_VISIBLE'),
  SET_TARGETS_LOADING: Symbol('SET_TARGETS_LOADING'),
  SET_TARGET_ROOMS: Symbol('SET_TARGET_ROOMS'),
  SET_TARGET_ROOMTYPES: Symbol('SET_TARGET_ROOMTYPES'),
  RESET_TARGETS: Symbol('RESET_TARGETS'),
  SET_SELECTED_TARGET_ROOM: Symbol('SET_SELECTED_TARGET_ROOM'),
  SET_SELECTED_TARGET_ROOM_ID: Symbol('SET_SELECTED_TARGET_ROOM_ID'),
};

export default actionTypes;
